export default {
  DIAGNOSES: 'diagnoses'
};